export default __webpack_public_path__ + "static/147-723b79865a59b94185245b32834fba1e.gif";